module.exports = __webpack_public_path__ + "files/a525735b508b86ae74d71dd4f12eddc6.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/objects-6.png
// module id = 524
// module chunks = 76